import * as types from '../mutation-types'
import { api } from '@/modules/api/index'
import saveFileFromBase64 from '@/utils/saveFileFromBase64'

export const state = {
  listings: null,
  statusesCount: {},
  totalPages: 0,
  totalItems: 10,
  listingPayload: null
}

export const getters = {
  listings: state => state.listings,
  getTotalItemsListings: state => state.totalItems,
  getCounterListing: state => state.statusesCount
}

export const actions = {
  listingPayloadAction ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      commit(types.SET_LISTING_PAYLOAD, payload)
    } catch (err) {
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchListing ({ commit, state }, payload) {
    payload = payload || state.listingPayload || {}
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.listing.getListing(payload))
      commit(types.SET_LISTING, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchCounterListing ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.listing.counterListing())
      commit(types.SET_COUNTER_LISTING, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing counter wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createListing ({ commit, dispatch }, listing) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.listing.createListing(), listing)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Listing was created successfully')
      await dispatch('fetchListing')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing wasn\'t created')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateListing ({ commit, dispatch }, listings) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.listing.updateListing(), { listings })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Listing was edited successfully')
      await dispatch('fetchListing')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing wasn\'t edited')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updatePendingListing ({ commit, dispatch }, listing) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.listing.updatePendingListing(), listing)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Listing was edited successfully')
      await dispatch('fetchListing')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing wasn\'t edited')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateApproveListing ({ commit }, editListing) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.post(api.listing.updateApproveListing(editListing))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Listing was edited successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing wasn\'t edited')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async remindListing ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.post(api.listing.remindListing(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Listing was edited successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing wasn\'t edited')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteListing ({ commit }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios({ method: 'delete', url: api.listing.deleteListing(id) })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Listing was deleted successfully')
      return response
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing wasn\'t deleted')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async exportListingPDF ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data } = await this.$axios({
        method: 'get',
        url: api.listing.exportListingPDF(),
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, 'ListingPDF', 'zip')
      commit(types.CREATE_SUCCESS_MESSAGE, 'Listing was Exported PDF')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing wasn\'t Exported PDF')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createPreviewListingPDF ({ commit }, Metadata) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios({
        method: 'post',
        url: api.listingInvitation.createPreviewListingPDF(),
        responseType: 'arraybuffer',
        data: { Metadata }
      })
      return response.data
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Listing PDF wasn\'t taken')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async resetListingStatus ({ commit, dispatch }, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.listing.resetStatusToNotYet(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Status was reset successfully')
      await dispatch('fetchListing')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Status reset failed')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

export const mutations = {
  [types.SET_LISTING] (state, { listings, totalPages, totalItems }) {
    state.listings = [...listings]
    state.totalPages = totalPages
    state.totalItems = totalItems
  },
  [types.SET_COUNTER_LISTING] (state, { statusesCount }) {
    state.statusesCount = { ...statusesCount }
  },
  [types.SET_LISTING_PAYLOAD] (state, payload) {
    state.listingPayload = payload
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/listing.js